module.exports = __webpack_public_path__ + "img/9.47b93239.jpg";